export const isSameSenderMargin = (messages, m, i, userId) => {
  if (
    i < messages.length - 1 &&
    messages[i + 1].sender._id === m.sender._id &&
    messages[i].sender._id !== userId
  )
    return 33;
  else if (
    (i < messages.length - 1 &&
      messages[i + 1].sender._id !== m.sender._id &&
      messages[i].sender._id !== userId) ||
    (i === messages.length - 1 && messages[i].sender._id !== userId)
  )
    return 0;
  else return "auto";
};

export const isSameSender = (messages, m, i, userId) => {
  return (
    i < messages.length - 1 &&
    (messages[i + 1].sender._id !== m.sender._id ||
      messages[i + 1].sender._id === undefined) &&
    messages[i].sender._id !== userId
  );
};

export const isLastMessage = (messages, i, userId) => {
  return (
    i === messages.length - 1 &&
    messages[messages.length - 1].sender._id !== userId &&
    messages[messages.length - 1].sender._id
  );
};

export const isSameUser = (messages, m, i) => {
  return i > 0 && messages[i - 1].sender._id === m.sender._id;
};

export const getSender = (loggedUser, users) => {
  if (users.length < 2) {
    return "Unknown Sender";
  }
  const [user1, user2] = users;
  return user1?._id === loggedUser?._id
    ? user2.name || "Unknown Sender"
    : user1.name || "Unknown Sender";
};

export const getSenderFull = (loggedUser, users) => {
  if (users.length < 2) {
    return null;
  }
  return users[0]._id === loggedUser._id ? users[1] : users[0];
};


// export const getSender = (loggedUser, users) => {
//   if (users.length < 2) {
//     return "Unknown Sender";
//   }
//   const [user1, user2] = users;
//   return user1?._id === loggedUser?._id ? user2.name : user1.name;
// };

// export const getSenderFull = (loggedUser, users) => {
//   if (users.length < 2) {
//     return null;
//   }
//   return users[0]._id === loggedUser._id ? users[1] : users[0];
// };
